// Detect a failed dynamic import of a route's code-split chunk.
// After a deploy, the PWA service worker purges the old hashed chunk filenames
// and a still-open client that navigates to a not-yet-loaded lazy route will
// request a file that no longer exists. This helper identifies those errors
// so the router can recover with a single guarded reload.
export function isChunkLoadError(error) {
  if (!error || typeof error !== "object") return false;
  if (error.name === "ChunkLoadError") return true;
  const message = error.message || String(error);
  return (
    /failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /imported module.*could not be loaded/i.test(message) ||
    /importing a module script failed/i.test(message) ||
    /loading chunk.*failed/i.test(message)
  );
}
